import { createFileRoute } from '@tanstack/react-router'
import { InventoriesLayout } from '@/features/inventories/components'

export const Route = createFileRoute('/_authenticated/inventories')({
  component: InventoriesLayout,
})
